function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwListbox from 'viewmodel/AwListboxViewModel';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/accEventBus', () => import('js/accEventBus'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "imports": ["js/lovService"],
  "ports": {},
  "actions": {
    "onAfterLovSelection": {
      "actionType": "Event",
      "method": "Event",
      "inputData": {
        "events": [{
          "name": "des.ownership.input.changed",
          "eventData": {
            "value": "{{data.ownershipLov.dbValue}}",
            "uiValue": "{{data.ownershipLov.uiValue}}"
          }
        }]
      },
      "events": {
        "success": [{
          "name": "ownershipInputChanged",
          "eventData": {
            "ownershipInput": {
              "value": "{{data.ownershipLov.dbValue}}",
              "uiValue": "{{data.ownershipLov.uiValue}}"
            }
          }
        }]
      }
    },
    "publishToACCEventBus": {
      "actionType": "JSFunction",
      "method": "publish",
      "inputData": {
        "eventId": "{{parameters.eventId}}",
        "eventData": "{{parameters.eventData}}"
      },
      "deps": "js/accEventBus"
    }
  },
  "data": {
    "ownershipLov": {
      "displayName": "Owner",
      "name": "owner",
      "type": "STRING",
      "isRequired": false,
      "hasLov": true,
      "dbValue": "anyOwner",
      "dispValue": "{{i18n.anyOwner}}"
    },
    "ownershipLovValues": {
      "type": "STRING",
      "dbValue": [{
        "propDisplayValue": "{{i18n.anyOwner}}",
        "dispValue": "{{i18n.anyOwner}}",
        "propInternalValue": "anyOwner"
      }, {
        "propDisplayValue": "{{i18n.me}}",
        "dispValue": "{{i18n.me}}",
        "propInternalValue": "me"
      }]
    }
  },
  "i18n": {
    "anyOwner": ["projectMessages"],
    "me": ["projectMessages"]
  },
  "lifecycleHooks": {},
  "onEvent": [{
    "eventId": "ownershipInputChanged",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des.ownership.input.changed",
      "eventData": "{{eventData.ownershipInput}}"
    }
  }],
  "props": {
    "accsessionid": {
      "type": "string"
    }
  },
  "conditions": {},
  "_viewModelId": "OwnershipLov",
  "_uniqueViewModelId": "OwnershipLov",
  "ctx": {}
};

/*
<div class="des-search-box-view-container">
    <div class="des-search-box-view-category">
        <aw-listbox prop="data.ownershipLov" list="data.ownershipLovValues.dbValue" labeldisplay="headless" action="onAfterLovSelection">
        </aw-listbox>
    </div>
</div>
*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement("div", {
    className: "des-search-box-view-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "des-search-box-view-category"
  }, /*#__PURE__*/React.createElement(AwListbox, _extends({}, getField("data.ownershipLov", fields, $index, null, null), {
    list: AwParseService.instance("data.ownershipLovValues.dbValue")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    labeldisplay: "headless",
    action: actions.onAfterLovSelection
  }))));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;